// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3589":"4fbb37ea","5355":"950a87d0"}[chunkId] + ".chunk.css";
};